import { render, staticRenderFns } from "./room-rate.vue?vue&type=template&id=18aa7349&scoped=true"
import script from "./room-rate.vue?vue&type=script&lang=js"
export * from "./room-rate.vue?vue&type=script&lang=js"
import style0 from "./room-rate.vue?vue&type=style&index=0&id=18aa7349&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aa7349",
  null
  
)

export default component.exports